module.exports = __webpack_public_path__ + "static/media/About-banner.c76ffaf3.jpg";